import React from 'react';

export const Header = () => {
    return (
        <div>
            <nav className='flex bg-white p-10 justify-center items-center'>
                <span className='font-serif text-black text-xl tracking-tight'>Chermo</span>
            </nav>
        </div>
    );
}